import { Autocomplete } from "@mui/material";
import CommonTextField from "../../commonTextField/CommonTextField";

export interface SelectOption {
  value: string;
  label: string;
}

type Props<T = SelectOption> = {
  value: T;
  options: T[];
  onChange: (value: string) => void;
  getOptionLabel?: (option: T) => string;
  getOptionValue?: (option: T) => string;
};

export const AutocompleteSelect = <T,>({
  value,
  onChange,
  options,
  getOptionLabel,
  getOptionValue,
}: Props<T>) => {
  const resolveOptionValue = (option: T) =>
    getOptionValue ? getOptionValue(option) : (option as SelectOption).value;

  const resolveOptionLabel = (option: T) =>
    getOptionLabel ? getOptionLabel(option) : (option as SelectOption).label;

  return (
    <Autocomplete
      value={value}
      options={options}
      getOptionLabel={(option) => resolveOptionLabel(option)}
      isOptionEqualToValue={(option, val) => option === val}
      renderInput={(params) => <CommonTextField {...params} size="small" />}
      onChange={(_, newValue) => onChange(resolveOptionValue(newValue as T))}
    />
  );
};
